import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import StandardTableVue from "@/components/table/StandardTable.vue";
import { getApiErrorData, getDeployData, resolveError } from "@/services/systemsetting";
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("../i18n-basucSettings"),
  data: function data() {
    return {
      dataList: [],
      dataLoading: false,
      columns: [{
        title: this.$t('deploy.apiPath'),
        dataIndex: 'interfaceName',
        width: 100
      }, {
        title: this.$t('deploy.errorCount'),
        dataIndex: 'errorCount',
        width: 1
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: 1
      }],
      resolveErrorLoading: false
    };
  },
  created: function created() {
    this.getData();
  },
  methods: {
    onResolveError: function onResolveError(record) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!_this.resolveErrorLoading) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this.resolveErrorLoading = true;
              _context.p = 2;
              _context.n = 3;
              return resolveError({
                ids: [record.interfaceName]
              });
            case 3:
              res = _context.v;
              if (res.data.code == 200) {
                _this.$message.success(_this.$t('deploy.OK'));
                _this.getData();
              }
            case 4:
              _context.p = 4;
              _this.resolveErrorLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2,, 4, 5]]);
      }))();
    },
    getData: function getData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.dataLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return getApiErrorData();
            case 2:
              res = _context2.v;
              if (res.data.code == 200) {
                _this2.dataList = res.data.data;
              }
            case 3:
              _context2.p = 3;
              _this2.dataLoading = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1,, 3, 4]]);
      }))();
    }
  }
};